import { fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { SelectProjectGroupFormViewModel } from "../types";

export default function SelectProjectGroupFormApp(props: SelectProjectGroupFormViewModel) {
  const [selectedProjectId, setSelectedProjectId] = useState(props.values.selectedProjectId);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting || !selectedProjectId) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("SelectedProjectId", selectedProjectId);
      formData.append("submit", props.submitText);

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      if (!response.ok) {
        throw new Error(await response.text());
      }

      window.location.reload();
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : "Akci se nepodarilo provest.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app select-project-group-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="form-group login-password">
          <div className="form-group">
            <label htmlFor="project-group-selector">{props.labels.project}</label>
            <select
              id="project-group-selector"
              className="form-control"
              value={selectedProjectId}
              disabled={isSubmitting}
              onChange={(event) => {
                setSelectedProjectId(event.currentTarget.value);
                setErrorMessage(null);
              }}
            >
              <option value="">{props.placeholder}</option>
              {props.values.projectGroups.map((projectGroup) => (
                <option key={projectGroup.value} value={projectGroup.value}>
                  {projectGroup.text}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <button
            type="button"
            className="btn btn-block btn-lg btn-primary"
            disabled={isSubmitting || !selectedProjectId}
            onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
          >
            {isSubmitting ? `${props.submitText}...` : props.submitText}
          </button>
        </div>
      </div>
    </div>
  );
}
